<div [ngClass]="{'ng-invalid ng-dirty': isCurrentlyInvalid}">
	<label>{{ 'form.field.customer' | translate }}<span *ngIf="required" class="text-danger">*</span></label>
	<div class="d-flex">
		<ng-container *ngIf="!isMobile(); else mobileDropdownBtn">
			<p-dropdown [options]="customersList" [optionLabel]="getCustomerNameProperty()" optionValue="customer_id"
				[(ngModel)]="_value" [inputId]="controlName" [placeholder]="'form.field.customerPlaceholder' | translate"
				(onChange)="onCustomerSelectionChange($event.value)" (onBlur)="propagateTouched()" [filter]="true"
				filterBy="customer_name_en,customer_name_ar,customer_name_he,customer_vat_number,id_number,customer_phone"
				[showClear]="false" [disabled]="_disabled"
				autofocusFilter="false"
				resetFilterOnHide="true"
				[styleClass]="isCurrentlyInvalid ? 'p-invalid w-100 flex-grow-1' : 'w-100 flex-grow-1'">
				<ng-template let-item pTemplate="item">
					<div>{{ getCustomerName(item) }}</div>
					<small class="fs-mini me-3" *ngIf="item?.id_number">ID: {{ item.id_number }}</small>
					<!-- <small class="fs-mini" *ngIf="item?.customer_vat_number">VAT: {{ item.customer_vat_number }}</small> -->
					</ng-template>
					<ng-template let-item pTemplate="selectedItem">
						{{ getCustomerName(item) }}
					</ng-template>
					</p-dropdown>
		</ng-container>
		<ng-template #mobileDropdownBtn>
			<button pButton type="button"
				[label]="_value ? getSelectedCustomerName() : ('form.field.customerPlaceholder' | translate)"
				icon="pi pi-chevron-down" class="flex-grow-1 justify-content-between" (click)="openMobileDropdown()"
				[disabled]="_disabled">
			</button>
		</ng-template>
		<button pButton type="button" icon="pi pi-user-plus" class="flex-shrink-0 d-none d-md-inline" (click)="openAddCustomerModal()"
			[title]="'shared.customerSelect.addNewCustomerTooltip' | translate">
		</button>
	</div>
	<div *ngIf="isCurrentlyInvalid" class="invalid-feedback text-danger d-block">
		{{ currentErrorMessage }}
	</div>
</div>

<p-dialog
	#dialogRef
	header="{{ 'shared.customerSelect.chooseCustomer' | translate }}"
	[(visible)]="isMobileDropdownOpen"
	[modal]="true"
	[contentStyle]="getMobileDialogContentStyle()"
	[baseZIndex]="1100"
	[modal]="true"
	[style]="{width: '80vw', minWidth: '350px'}"
	[draggable]="false"
	[resizable]="false"
	[maximizable]="true"
	[breakpoints]="{'768px': '100vw'}"
	(onHide)="closeMobileDropdown()">
	<div class="mb-3 p-input-icon-right w-100">
		<i *ngIf="searchTerm" class="pi pi-times" (click)="searchTerm = ''"></i>
		<input type="text" class="form-control w-100" [placeholder]="'form.field.customerPlaceholder' | translate"
			[(ngModel)]="searchTerm" autocomplete="off" style="width: 100% !important;" />
	</div>
	<div style="flex:1 1 auto; overflow-y:auto; max-height:70vh;">
		<div *ngFor="let item of filteredCustomers" class="customer-list-item py-2 px-2 border-bottom"
			[ngClass]="{'bg-light': item.customer_id === _value, 'customer-list-item-hover': true}"
			(click)="selectCustomer(item)">
			<div>{{ getCustomerName(item) }}</div>
			<small class="fs-mini" *ngIf="item?.id_number">ID: {{ item.id_number }}</small>
			<!-- <small class="fs-mini" *ngIf="item?.customer_vat_number">VAT: {{ item.customer_vat_number }}</small> -->
		</div>
		<div *ngIf="filteredCustomers.length === 0" class="text-center text-muted py-4">
			{{ 'shared.customerSelect.noResults' | translate }}
		</div>
	</div>
	<ng-template pTemplate="footer">
		<button pButton type="button" class="mx-0 mt-3" icon="pi pi-user-plus"
			label="{{ 'shared.customerSelect.addNewCustomerTooltip' | translate }}"
			(click)="closeMobileDropdown(); openAddCustomerModal()"></button>
	</ng-template>
</p-dialog>

<app-add-customer-modal [showModal]="showAddCustomerModal" [debug]="debug" (onSave)="handleCustomerModalSave($event)"
	(onClose)="handleCustomerModalClose()">
</app-add-customer-modal>